import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { WifiOff, Heart, Brain, Star } from './Icons';
export function HeroSection() {
  return <section className="relative pt-10 pb-12 md:pt-24 md:pb-32 px-4 overflow-hidden bg-cream" data-id="element-67">
      <div className="max-w-3xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center space-y-4 md:space-y-6 z-10" data-id="element-69">
          <div className="inline-flex items-center gap-2 bg-amber-light text-warm-dark px-4 py-2 rounded-full text-sm font-bold w-fit mb-2" data-id="element-70">
            <Star className="w-4 h-4 text-amber" data-id="element-71" />
            <span data-id="element-72">Para madres agotadas de pelear por las pantallas</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-navy leading-tight text-balance" data-id="element-73">
            ¿Tu hijo está{' '}
            <span className="text-terracotta relative" data-id="element-74">
              "secuestrado"
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-terracotta/30" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-75">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="transparent" data-id="element-76" />
              </svg>
            </span>{' '}
            por las pantallas?
          </h1>

          <p className="text-xl md:text-2xl text-warm-dark font-medium leading-relaxed" data-id="element-77">
            Recupera su atención, su creatividad y su paz mental en 30 días sin
            gritos ni peleas constantes...
          </p>

          <div className="flex items-start gap-3 bg-white/60 p-4 rounded-xl border border-cream-dark text-left" data-id="element-78">
            <WifiOff className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-79" />
            <p className="text-lg text-warm-medium italic" data-id="element-80">
              — Incluso si hoy parece "adicto" y llora cada vez que apagas el
              Wi-Fi.
            </p>
          </div>

          {/* Mockup image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative w-full max-w-lg mx-auto my-2 md:my-4" data-id="element-81">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/w6tcuMDdoFG3K8Zzdh2vn6/mk1.png" alt="Infancia Analógica Ebook en iPad con niño jugando bloques de madera" className="w-full h-auto object-cover" data-id="element-83" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent" data-id="element-84"></div>
            </div>

            {/* Floating badges */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg border border-cream-dark flex items-center gap-3" data-id="element-85">
              <div className="bg-sage-light p-2 rounded-full" data-id="element-86">
                <Brain className="w-6 h-6 text-sage" data-id="element-87" />
              </div>
              <div data-id="element-88">
                <p className="text-xs text-warm-medium font-bold uppercase" data-id="element-89">
                  Método
                </p>
                <p className="text-sm text-navy font-bold" data-id="element-90">Neuro-amigable</p>
              </div>
            </motion.div>

            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 5,
            ease: 'easeInOut'
          }} className="absolute -top-6 -right-6 bg-white p-4 rounded-xl shadow-lg border border-cream-dark flex items-center gap-3" data-id="element-91">
              <div className="bg-amber-light p-2 rounded-full" data-id="element-92">
                <Heart className="w-6 h-6 text-amber" data-id="element-93" />
              </div>
              <div data-id="element-94">
                <p className="text-xs text-warm-medium font-bold uppercase" data-id="element-95">
                  Resultados en
                </p>
                <p className="text-sm text-navy font-bold" data-id="element-96">30 Días</p>
              </div>
            </motion.div>
          </motion.div>

          <div className="pt-4 w-full" data-id="element-97">
            <CTAButton data-id="element-98" />
          </div>
        </motion.div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-amber-light/40 rounded-full blur-3xl -z-10" data-id="element-99"></div>
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-terracotta/10 rounded-full blur-3xl -z-10" data-id="element-100"></div>
    </section>;
}